/**
 * This is the driver for order confirm.  Each step is its own component that allows them
 * to easily be changed and order swapped around.  Each component updates what it needs to
 * (as opposed to stepperhome.js that relies on each component to update state and then
 * submits at the end)
 */
import React from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Grid, Paper, Typography } from '@mui/material';

import LoadingSpinner from '../ui/LoadingSpinner';
import PageTitle from '../ui/PageTitle';
import ServerError from '../ui/ServerError';

import AbEnvironment from '../auth/AbEnvironment';

import StepperSubscriptionOrder from './StepperSubscriptionOrder';
import AppBindStyles from '../../AppBindStyles';

const abEnvironment = new AbEnvironment();
const StepSignUpCheckEmailQuery = graphql`
query StepSignUpCheckEmailQuery($accountId: UUID) {

  allSubscriptionOrderTs(condition: {accountId:  $accountId, orderStatus: 0}) 
   { totalCount nodes { orderStatus orderContent subscriptionOrderId } } 
  }
`;

const styles = theme => ({
  root: {
    margin: "0 auto",
    padding: "0 72px"
  },  
  signupPaper: {
    borderTopRightRadius: "10px",
    borderTopLeftRadius: "10px",
    borderBottomRightRadius: "10px",
    borderBottomLeftRadius: "10px",
    maxWidth: 600,
    width: "100%",
    minHeight: 200

  },
  title: {
    paddingTop: 8,
    paddingBottom: 8,
    backgroundColor: theme.palette.secondary.main,
    
    borderTopRightRadius: "10px",
    borderTopLeftRadius: "10px"
  },
  titleLine: {
    color : "white", 
    fontSize: "21px",
    fontWeight: "500",
    paddingLeft: "16px",
    paddingTop: "24px",
    paddingBottom: "8px"
  },
  stepper: {
    borderBottomRightRadius: "10px",
    borderBottomLeftRadius: "10px",
  },
  logo: {
    marginLeft: '8px', 
    marginBottom: '-6px'
  }
});


class StepSignUpCheckEmail extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      

    };
  }

  componentDidMount() {
    

  }
  
  render() {
    const { logError } = this.props.auth;
    const classes = this.props.classes;

    const params = new URLSearchParams(this.props.location.search);
    let accountId = params.get('accountId');


    return (
      <QueryRenderer
        environment={abEnvironment.getEnvironment()}
        query={StepSignUpCheckEmailQuery}
        variables={{accountId: accountId, forceFetch: this.state.forceFetch}}
        render={({error, props})=> {
          if (error) {
            logError(error.message);
            return (
              <ServerError/>
            );
          } else if (props) {
            if (props.allSubscriptionOrderTs === null)
            {
              return (
                <div className={classes.root}>
                  <PageTitle title={"Something is not correct, please contact Appbind support"}/>
                </div>
              );
            } else {

              var json = props.allSubscriptionOrderTs.nodes[0].orderContent;

              return (

                <div className={classes.root}>

                <Grid container spacing={3} direction="row" justifyContent="center">
        
                  <Grid item  md={12} lg={5}  style={{width:"100%", marginLeft:16, marginRight:16, marginTop: 24}}>
                
                    <Grid container justifyContent="center" spacing={2}>
                      <Paper className={classes.signupPaper}>
        
                        <Grid item  xs={12}>
                          <div className={classes.title}>
                            <Typography variant="h4" className={classes.titleLine} >
                                Confirm your email
                            </Typography>
                          </div>
                        </Grid>
        
        
                        <Grid item xs={12}>
                          <Grid container direction="row" spacing={2} >
                            <Grid item  xs={12} style={{paddingTop: '24px', paddingLeft: '24px', paddingRight: '24px'}}>
                              <div>
                                <Typography variant="body1" style={AppBindStyles.boldLabel}>
                                  Check your email!
                                </Typography>
                                <Typography variant="body2" style={{marginTop:4}}>
                                  We sent you an email to confirm your account. Click on the link in the 
                                  confirmation email to continue.
                                </Typography>
                              </div>
                            </Grid>
       
                          </Grid>
                        </Grid>
                      </Paper>
                    </Grid>
                  </Grid>
        
                  <Grid item md={12} lg={5} style={{width:"100%", marginLeft:16, marginRight:16, marginTop: 24}}>
                    <StepperSubscriptionOrder auth={this.props.auth} json={json} />
                  </Grid>
        
                </Grid>
        
              </div>
        
              );

            }
          }
          return <LoadingSpinner />
        }}
      />
    )
  }
  
}

export default withStyles(styles)(StepSignUpCheckEmail);